export const roomDescription = {
  type: "string",
  minLength: 0,
  maxLength: 255
};
